import { ROOT_WORKFLOW_FOLDER_NAME, ROOT_WORKFLOW_FOLDER_DISPLAY_NAME } from '../constants';

export const formatFolderName = (folderName: string) =>
  folderName === ROOT_WORKFLOW_FOLDER_NAME ? ROOT_WORKFLOW_FOLDER_DISPLAY_NAME : folderName;
